export default __webpack_public_path__ + "static/media/LockIconFullWhite.b097def8.svg";